import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import http from '../../http-common';
import './Login.css';
import myImage from '../../utils/images/aquatrio-logo.png';

const Login = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');

    try {
        const response = await http.post('/users/auth/login', {
            email,
            password,
        });

        const { token, user } = response.data;

        localStorage.setItem('authToken', token);
        localStorage.setItem('userData', JSON.stringify(user));
        console.log('Logged in as:', user);
        onLogin();
        navigate('/landing');
    } catch (err) {
        if (err.response && err.response.data.message) {
            setError(err.response.data.message); 
        } else if (err.message) {
            setError('Network error. Please try again.'); 
        } else {
            setError('An unexpected error occurred.');
        }
    }
};

  return (
    <div className="login-container">
      <div className="login-left">
      <img src={myImage} alt="App Logo" className="logo-image" />
        
      </div>

      <div className="login-right">
        <h2>Login</h2>
        <form className="login-form" onSubmit={handleLogin}>
          <input
            type="text"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">LOGIN</button>
        </form>
        {error && <p className="error-message">{error}</p>}
        <p className="forgot-link">
          <span onClick={() => navigate('/forgot-password')}>Forgot Password?</span>
        </p>
      </div>
    </div>
  );
};

export default Login;
